import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=4b0bf7c3&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0bf7c3')) {
      api.createRecord('4b0bf7c3', component.options)
    } else {
      api.reload('4b0bf7c3', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=4b0bf7c3&", function () {
      api.rerender('4b0bf7c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24K9VcD1MHU5H/JS/cancellationPolicy.vue"
export default component.exports